// https://github.com/lodash/lodash/blob/4.0.8-npm-packages/lodash.debounce/index.js
// 정해진 시간(wait) 내에 가장 마지막에 발생한 이벤트만 동작하도록
export function debounce(func: Function, wait: number = 50, immediate?: boolean) {
  let timeout

  const debounced = function(...args) {
    /* tslint:disable:no-this-assignment */
    const context = this

    const later = function() {
      timeout = null

      if (!immediate) {
        func.apply(context, args)
      }
    }

    const callNow = immediate && !timeout

    clearTimeout(timeout)
    timeout = setTimeout(later, wait || 200)

    if (callNow) {
      func.apply(context, args)
    }
  }

  debounced.prototype.cancel = function cancel() {
    clearTimeout(timeout)
    timeout = null
  }

  return debounced
}
